export const redirect = (url: string) => {
  // eslint-disable-next-line spellcheck/spell-checker
  window.location.href = url;
  return null;
};
